function requireString(value: string | undefined, name: string): string {
  if (!value) {
    throw new Error(
      `Missing required environment variable: ${name}. Set it in .env.local.`,
    )
  }
  return value
}

function optional(value: string | undefined): string | undefined {
  return value && value.length > 0 ? value : undefined
}

/**
 * All runtime env vars used by the client, resolved once and typed. Pulled from
 * Vite's `import.meta.env`. Anything sensitive (secrets) MUST NOT live here —
 * these are all prefixed with VITE_ and shipped to the browser.
 */
export const env = {
  apiUrl: requireString(import.meta.env.VITE_API_URL, 'VITE_API_URL'),
  /** Base URL of the Score platform (no trailing slash); point at score-mock in local dev. */
  scoreUrl: optional(import.meta.env.VITE_SCORE_URL) ?? 'https://score.fpf.pt',
  defaultClub: optional(import.meta.env.VITE_DEFAULT_CLUB),
  defaultLocale:
    optional(import.meta.env.VITE_DEFAULT_LOCALE) ??
    (import.meta.env.PROD ? 'pt' : 'en'),
  appName: optional(import.meta.env.VITE_APP_NAME) ?? 'Sprint',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const

export type Env = typeof env
